<script lang="ts">
	import { createPromiseStore } from "../../../../core/utils/createPromiseStore.js";
	import { onMount } from "svelte";
	import { cartPathMap } from "../../../../core/schema/paths/cartPathMap.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import Button from "../Button.svelte";
	import cake from "../../../../core/assets/icons/cake.svg?raw";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { reportAddedVoucherToCart, reportVoucherDetail } from "../../UniversalAnalytics.js";

	import Form from "../Form/Form.svelte";
	import type { VoucherProduct } from "../../../../core/schema/VoucherProduct.js";
	import { getCartStore } from "../../contexts/cartStoreContextKey.js";

	export let voucher: VoucherProduct;

	const cartStore = getCartStore();
	const { TENANT_LOCALE } = getGlobalSettings();

	const putItemToCart = createPromiseStore(async (voucher: VoucherProduct) => {
		const response = await cartStore.addVoucher(voucher);
		reportAddedVoucherToCart(response.item, TENANT_LOCALE);
		return response;
	});

	onMount(() => {
		reportVoucherDetail(voucher, TENANT_LOCALE);
	});

	async function submit(): Promise<void> {
		await putItemToCart.call(voucher);
		window.location.assign(`/${cartPathMap[TENANT_LOCALE]}`);
	}
</script>

<Form on:submit={submit} class="mt-8">
	<div class="flex flex-col items-end gap-4 lg:justify-end">
		<span class="text-right text-xl font-semibold leading-7">
			{nbspify(formatPrice(voucher.value, TENANT_LOCALE, false))}
		</span>
		<div class="text-secondary flex items-end gap-2 text-[.8rem] leading-[1] opacity-60">
			bez DPH
			<span class="text-right text-base font-semibold">
				{nbspify(formatPrice(voucher.value, TENANT_LOCALE, false))}
			</span>
		</div>
	</div>

	<div class="mt-6 flex flex-col gap-2">
		<Button
			type="submit"
			class="w-full justify-center !rounded-[1.875rem] py-[1.063rem] text-[1.125rem] leading-6 md:text-[1.375rem]"
			variant="primary"
			icon={cake}
			iconClass="w-6"
			disabled={$putItemToCart.status === "loading"}
		>
			Přidat do krabice
		</Button>
	</div>
</Form>
